import { connect } from 'react-redux';
import { CREATIVES_RESOURCE_NAME } from 'explore/constants';
import { mapStateToProps as mapStateToControlsProps } from 'explore/containers/creatives_controls';
import AppliedFilters from 'common/filter/containers/applied';

export const mapStateToProps = (state) => {
  const {
    industryOptions, eliteOptions, platinumOptions, countryOptions, languageOptions,
    subcategoryOptions
  } = mapStateToControlsProps(state);

  return {
    resourceName: CREATIVES_RESOURCE_NAME,
    options: {
      "specializations.id": [ ...industryOptions, ...subcategoryOptions ],
      is_elite: eliteOptions,
      is_platinum: platinumOptions,
      country: countryOptions,
      all_langs: languageOptions
    },
    fieldLabels: {
      "specializations.id": "specialization",
      is_elite: "level",
      is_platinum: "level",
      all_langs: "language"
    }
  };
}

export default connect(mapStateToProps)(AppliedFilters);



// WEBPACK FOOTER //
// ./explore/containers/creatives_applied_filters.js